import React from "react";

import { Link } from "react-router-dom";

import { Tabs, PageHeader, Button, Divider, Alert, Popconfirm } from "antd";

import {
    DollarOutlined,
    OrderedListOutlined,
    FolderOpenOutlined,
    DashboardOutlined,
    CheckSquareOutlined,
    PrinterOutlined,
} from "@ant-design/icons";

import { LAYOUT_MANAGER_QUOTE_EDIT } from "../../navigation";

import { displayId } from "../../../../components/quote";
import { QuoteStatusDropdown } from "../../../../components/quote/status";
import TasksList from "./tasks";
import TasksFinances from "./finances";
import Details from "../../../../components/quote/show/details";
import { flashSuccess, flashError } from "../../../../core/utils/flashMessage";

const { TabPane } = Tabs;

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
        };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _allowEdit = () => {
        const { data } = this.props;

        if (data.quote && data.quote.job) {
            return false;
        }

        return true;
    };

    _allowChangeStatus = () => {
        const { data } = this.props;

        if (data && data.quote && data.quote.job) {
            return false;
        }

        return true;
    };

    _handleUpdateStatus = (item) => {
        const form = {
            status: item.key,
        };
        this.props.updateStatus(this.state.id, form);
    };

    _createBoxFolder = () => {
        this.setState({ loading: true });

        const ret = this.props.createBoxFolder(this.state.id);
        ret.then((response) => {
            flashSuccess({ description: "Folder created" });
            this.setState({ loading: false });
        }).catch((e) => {
            flashError({ description: "Unexpected error!" });
            this.setState({ loading: false });
        });
    };

    render() {
        const { data } = this.props;
        const allowEdit = this._allowEdit();
        const allowChangeStatus = this._allowChangeStatus();
        const disabled = !allowEdit;
        const downloadPdf = () => this.props.download(this.state.id);
        return (
            <>
                <div>
                    <PageHeader
                        ghost={false}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={`${displayId(data.quote.id)}`}
                        subTitle={data.quote.name}
                        extra={[
                            <Button ype="primary" size="small" onClick={downloadPdf}>
                                <PrinterOutlined />
                                <Divider type="vertical" />
                                PDF
                            </Button>,
                            <QuoteStatusDropdown
                                key="2"
                                onUpdateStatus={this._handleUpdateStatus}
                                status={data.quote.status}
                                disabled={!allowChangeStatus}
                            />,
                            <Link key="3" to={LAYOUT_MANAGER_QUOTE_EDIT(this.state.id)}>
                                <Button type="primary" size="small" disabled={disabled}>
                                    <i className="fa fa-pencil-square-o"></i>
                                    <Divider type="vertical" />
                                    Update
                                </Button>
                            </Link>,
                        ]}
                    >
                        <Details quote={data.quote} column={2} allowEdit={allowEdit} />
                    </PageHeader>

                    <Divider />

                    {(this.props.data.agreement || []).length === 0 && (
                        <Alert type="error" message="Please establish an agreement for this client." banner showIcon />
                    )}

                    <Tabs
                        defaultActiveKey="1"
                        type="card"
                        style={{ marginBottom: 32, arginTop: 32, backgroundColor: "#fff" }}
                    >
                        <TabPane
                            tab={
                                <span>
                                    {" "}
                                    <OrderedListOutlined /> Tasks{" "}
                                </span>
                            }
                            key="tasks"
                            style={{ minHeight: 400 }}
                        >
                            <TasksList
                                full
                                quote={this.props.data.quote}
                                {...this.props}
                                allowEdit={allowEdit}
                                catlogs={this.props.data.catlogs}
                            />
                        </TabPane>

                        <TabPane
                            tab={
                                <span>
                                    {" "}
                                    <DollarOutlined /> Finances{" "}
                                </span>
                            }
                            key="finances"
                            style={{ minHeight: 400 }}
                        >
                            <TasksFinances
                                id={this.state.id}
                                tasks={this.props.data.quote.qTasks}
                                allowEdit={allowEdit}
                                updatePrices={this.props.updatePrices}
                                actionLoading={this.props.actionLoading}
                            />
                        </TabPane>
                    </Tabs>
                </div>
            </>
        );
    }
}
